import { useEffect, useState } from "react";
import { Container } from "../Container/container";
import "./petsStories.css";

const API_KEY = "50853697-ccd9acb9abbdf256f1feb5e3f";

export const PetsStories = () => {
  const [photos, setPhotos] = useState([]);
  const [page, setPage] = useState(1);

  const fetchPhotos = async () => {
    const response = await fetch(
      `https://pixabay.com/api/?key=${API_KEY}&q=pets&image_type=photo&per_page=4&page=${page}`
    );

    const data = await response.json();

    setPhotos(prev => [...prev, ...data.hits]);
  };

useEffect(() => {
  setPhotos([]);
  fetchPhotos();
}, [page]);

  return (
    <section id="news">
      <Container>
        <div className="pets">
          <h2 className="pets__title">Interacting with our pets</h2>

          <ul className="pets__list">
            {photos.map(photo => (
              <li key={photo.id} className="pets__item">
                <img
                  className="pets__img"
                  src={photo.webformatURL}
                  alt={photo.tags}
                />
                <p className="pets__desc">{photo.tags}</p>
              </li>
            ))}
          </ul>

          <button
            className="pets__button"
            onClick={() => setPage(prev => prev + 1)}
          >
            Load more
          </button>
        </div>
      </Container>
    </section>
  );
};